module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0_11105_12510)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 3.25C6.27208 3.25 3.25 6.27208 3.25 10C3.25 13.7279 6.27208 16.75 10 16.75C13.7279 16.75 16.75 13.7279 16.75 10C16.75 6.27208 13.7279 3.25 10 3.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10ZM6.75 8.33333C6.75 7.91912 7.08579 7.58333 7.5 7.58333H7.50833C7.92255 7.58333 8.25833 7.91912 8.25833 8.33333C8.25833 8.74755 7.92255 9.08333 7.50833 9.08333H7.5C7.08579 9.08333 6.75 8.74755 6.75 8.33333ZM11.75 8.33333C11.75 7.91912 12.0858 7.58333 12.5 7.58333H12.5083C12.9225 7.58333 13.2583 7.91912 13.2583 8.33333C13.2583 8.74755 12.9225 9.08333 12.5083 9.08333H12.5C12.0858 9.08333 11.75 8.74755 11.75 8.33333ZM7.11265 11.8267C7.40554 11.5338 7.88041 11.5338 8.17331 11.8267C9.18216 12.8355 10.8178 12.8355 11.8267 11.8267C12.1196 11.5338 12.5945 11.5338 12.8874 11.8267C13.1802 12.1196 13.1802 12.5945 12.8874 12.8874C11.2927 14.482 8.70729 14.482 7.11265 12.8874C6.81975 12.5945 6.81975 12.1196 7.11265 11.8267Z\" fill=\"currentColor\"/></g><defs><clipPath id=\"clip0_11105_12510\"><path fill=\"currentColor\" d=\"M0 0H20V20H0z\"/></clipPath></defs>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
